import { useCallback, useState } from 'react'
import TaskActualWorkApi, {
  TaskActualWorkList,
} from '../../../../lib/functions/taskActualWork'
import { open } from '../../../router'
import { resolvePathFromViewModel } from '../../../../domain/value-object/ViewModel'
import { ActualWork as DialogActualWork } from '../../../components/dialogs/TaskActualWorkTaskDialog'

export type TaskActualWorkTaskDialogState = {
  total: number
  date: string
  taskActualWorks: DialogActualWork[]
  anchorElement: Element | null
  clickEvent: {
    x: number
    y: number
    view: {
      innerWidth: number
      innerHeight: number
    } | null
  }
  openDetail?: () => void
}

export type openTaskActualWorkListProps = {
  userUuid: string | undefined
  projectUuid?: string | undefined
  projectCode?: string | undefined
  targetDate: string | undefined
  event: PointerEvent | undefined | null
}

export const useTaskActualWorkTaskDialogState = () => {
  const [taskDialogState, setTaskDialogState] =
    useState<TaskActualWorkTaskDialogState | null>(null)

  const openTaskActualWorkList = useCallback(
    async ({
      userUuid,
      projectUuid,
      projectCode,
      targetDate,
      event,
    }: openTaskActualWorkListProps) => {
      if (!userUuid || !targetDate || !event) return

      const tasks: TaskActualWorkList = (
        await TaskActualWorkApi.getTaskActualWorkList({
          userUuid,
          targetDate,
          projectUuid,
        })
      ).json
      if (!tasks) return
      // TODO: ViewModel移行完了後、旧フィールドへのフォールバックを削除する
      const taskActualWorks: DialogActualWork[] = tasks.taskActualWorks.map(
        w => {
          const resolvedPath = resolvePathFromViewModel(
            w.projectPlanPathViewModel,
            w.path
          )
          return {
            ...w,
            path: resolvedPath.value,
            pathStale: resolvedPath.stale,
          }
        }
      )

      const openDetail = projectCode
        ? () => {
            open(
              `/actualWork/${projectCode}?code=${tasks.taskActualWorks
                .map(actualWork => {
                  return actualWork.taskCode
                })
                .join(',')}`,
              event,
              undefined,
              true
            )
          }
        : undefined

      setTaskDialogState({
        total: tasks?.total || 0,
        date: targetDate,
        taskActualWorks,
        anchorElement: event.target as Element,
        clickEvent: event,
        openDetail,
      })
    },
    []
  )

  return {
    taskDialogState,
    setTaskDialogState,
    openTaskActualWorkList,
  }
}
